import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { LottieIcon } from '../atoms/icons/lottie_icon';
import { STREAK_FIRST_COMPLETION_MESSAGE, STREAK_FIRST_COMPLETION_TITLE_SUFFIX } from '../../messages';
const COMPLETION_ANIMATION_URL = '/assets/images/goal_matching_assessments/9calendar.json';
export const FirstStreakCompletionView = ({ streakCount }) => {
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement("div", { className: css(styles.title) }, `${streakCount}${STREAK_FIRST_COMPLETION_TITLE_SUFFIX}`),
        React.createElement(LottieIcon, { lottieDataUrl: COMPLETION_ANIMATION_URL, classObject: styles.illustration }),
        React.createElement("p", { className: css(styles.message) }, STREAK_FIRST_COMPLETION_MESSAGE)));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        gap: 40,
        textAlign: 'center',
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        letterSpacing: 1.44,
        lineHeight: 1.4,
    },
    message: {
        fontSize: 16,
        lineHeight: 1.4,
        letterSpacing: 1.28,
        margin: 0,
        whiteSpace: 'pre-wrap',
    },
    illustration: {
        width: 284,
        height: 243,
    },
});
